export default {"src":"/_next/static/media/sliver.b9d66734.svg","height":81,"width":175};